import React, {useEffect} from 'react';

//components
import InformationSquare from '../global/informationContainers/InformationSquare';
import BasicButton from '../global/buttons/BasicButton/BasicButton';

//interfaces
import { AudienceModalState } from  '@/interfaces/ContentAudienceModal';

//hooks
import useContentAudience from './ContentAudience.hook';


const TotalAudience = ({setAudienceModalState}: {setAudienceModalState:(state:AudienceModalState) => void}) => {
    const {audienceCounts, getAudienceCounts, isEditor}  = useContentAudience();

    useEffect(() => {
        getAudienceCounts();
        
        if((document.querySelector('.TotalAudience') as HTMLDivElement)) {
            (document.querySelector('.TotalAudience') as HTMLDivElement).style.height = `${187}px`
        }
    }, [])

    function handleNextPage(){
        setAudienceModalState(AudienceModalState.EditAudience)
    }

    return( 
        <section>
            <h2 className='total-audience-header'>Total Audience</h2>
            
            <div className='total-audience-wrapper'>
                <InformationSquare
                    title={<h3 className='total-audience-info-square-header'>{'User Groups'}</h3>}
                    mainContent={<p className='total-audience-info-square-body'>{audienceCounts.groupCount}</p>}
                />
                <InformationSquare 
                    title={<h3 className='total-audience-info-square-header'>{'Total Audience'}</h3>}
                    mainContent={<p className='total-audience-info-square-body'>{audienceCounts.audienceCount}</p>}
                />
            </div>

            {isEditor && <div className='audience-modal-control-wrapper'>
                <BasicButton content={'Edit Audience'} ariaLabel={'Edit Audience'} onButtonClick={handleNextPage}/>
            </div>}
        </section>
    )
}

export default TotalAudience
